<button
  [ngStyle]="{
    'background-color': buttonColor,
    'border-color': borderColor,
    'color': textColor,
    'min-width': minWidth,
    'font-size': fontSize,
    'height': buttonHeight,
    'text-transform': textTransform,
    'font-weight': fontWeight,
    'border-top-left-radius': borderRadiusTopLeft,
    'border-bottom-left-radius': borderRadiusBottomLeft
  }"
  class="custom-button"
  (click)="onClick($event)"
  [style.width]="isFullWidth ? '100%' : 'auto'"
  [disabled]="isDisabled"
  [ngClass]="additionalClass"
>
  <ng-container *ngIf="leadingIcon">
    <div class="pe-2">
      <img [src]="leadingIcon" alt="Leading Icon" class="icon leading-icon" [style.width]="leadingIconSize"
           [style.height]="leadingIconSize"
      />
    </div>
  </ng-container>

  <span class="button-text">{{ text }}</span>

  <ng-container *ngIf="trailingIcon">
    <img [src]="trailingIcon" alt="Trailing Icon" class="icon trailing-icon" [style.width]="trailingIconSize"
         [style.height]="trailingIconSize"
    />
  </ng-container>
</button>
